import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import HelpButton from "../components/HelpButton";
import SEO from "../components/SEO";
import { generateServiceSchema } from "../lib/schema";

function Voorwaarden() {
  return (
    <div className="min-h-screen bg-gray-50 page-transition pt-[99px] md:pt-[133px]">
     <SEO
  title="Voorwaarden - Elektraaanleggen.nl"
  description="Lees de voorwaarden van Elektraaanleggen.nl en ontdek hoe we werken en welke afspraken we met onze klanten maken."
  schema={generateServiceSchema({
    name: "Voorwaarden",
    description: "Bekijk de voorwaarden voor het gebruik van de diensten van Elektraaanleggen.nl, inclusief informatie over onze werkwijze en klantafspraken.",
    image: "https://elektraaanleggen.nl/images/banner.png",
  })}
/>

      <Header />

      <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1260px] mb-12 md:mb-20 pt-16 md:pt-24">
        <h1 className="font-bold text-black leading-[1.25] text-[28px] lg:text-[36px] text-[#17354A] block mb-4 leading-[35px] text-[2rem] md:inline-block md:mb-5 md:text-[44px] md:leading-[42px] lg:block">
          Algemene voorwaarden
        </h1>

        <div className="text-black leading-[1.56] text-[16px] md:text-[18px] font-normal text-[#17354A] mb-8">
          <p>
            Deze algemene voorwaarden zijn van toepassing op alle aanbiedingen
            en overeenkomsten van elektraaanleggen.nl.
          </p>

          <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6 mt-12">
            1. Definities
          </h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              <strong>Opdrachtnemer:</strong> elektraaanleggen.nl
            </li>
            <li>
              <strong>Opdrachtgever:</strong> De natuurlijke of rechtspersoon
              die de opdracht verstrekt
            </li>
            <li>
              <strong>Werkzaamheden:</strong> Alle elektrotechnische diensten en
              installaties
            </li>
          </ul>

          <h2 className="font-bold text-[24px] lg:text-[36px] text-[#17354A] mt-12 mb-6">
            2. Offertes en aanbiedingen
          </h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Alle offertes zijn vrijblijvend en 30 dagen geldig</li>
            <li>Prijzen zijn exclusief BTW tenzij anders vermeld</li>
            <li>
              Aanbiedingen zijn gebaseerd op de door opdrachtgever verstrekte
              informatie
            </li>
          </ul>

          <h2 className="font-bold text-[24px] lg:text-[36px] text-[#17354A] mt-12 mb-6">
            3. Uitvoering van werkzaamheden
          </h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              Werkzaamheden worden uitgevoerd volgens geldende normen en
              voorschriften
            </li>
            <li>Opdrachtgever zorgt voor toegang en benodigde voorzieningen</li>
            <li>
              Wijzigingen in de opdracht worden schriftelijk overeengekomen
            </li>
          </ul>

          <h2 className="font-bold text-[24px] lg:text-[36px] text-[#17354A] mt-12 mb-6">
            4. Garantie en aansprakelijkheid
          </h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>2 jaar garantie op installatiewerkzaamheden</li>
            <li>Fabrieksgarantie op gebruikte materialen</li>
            <li>Aansprakelijkheid beperkt tot het factuurbedrag</li>
          </ul>

          <h2 className="font-bold text-[24px] lg:text-[36px] text-[#17354A] mt-12 mb-6">
            5. Betaling
          </h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Facturen dienen binnen 14 dagen te worden voldaan</li>
            <li>
              Bij grotere projecten kunnen termijnbetalingen worden afgesproken
            </li>
            <li>
              Bij niet-tijdige betaling worden wettelijke rente en incassokosten
              in rekening gebracht
            </li>
          </ul>

          <h2 className="font-bold text-[24px] lg:text-[36px] text-[#17354A] mt-12 mb-6">
            Contact
          </h2>
          <p>
            Heeft u vragen over onze voorwaarden? Neem dan contact met ons op
            via:
          </p>
          <p className="mt-4">
            elektraaanleggen.nl
            <br />
            Laan van vollenhove 2935 <br />
            3706 AK Zeist
            <br />
            info@elektraaanleggen.nl
          </p>
        </div>
      </section>

      <HelpButton />
      <Footer />
    </div>
  );
}

export default Voorwaarden;
